import { useTranslation } from "@opendash/i18n";
import { FixedDescription } from "@opendash/ui";
import { Card, Descriptions, Typography } from "antd";
import { DescriptionsItemType } from "antd/lib/descriptions";
import { observer } from "mobx-react-lite";
import React from "react";
import { PriorityTag, useTicketData } from "../../..";
import { MessagesTile } from "../../../../../_shared/print/components/MessagesTile";
import { UserNoticeTile } from "../../../../../_shared/print/components/UserNoticeTile";

const { Text } = Typography;

export const TicketPrintTile = observer(() => {
  const t = useTranslation();
  const ticketData = useTicketData();
  const descriptionItems: DescriptionsItemType[] = [
    {
      key: 0,
      span: 45,
      label: (
        <Text strong>
          {t("maintenance:monitor.daily_schedule.print.ticket.title")}
        </Text>
      ),
      children: <Text strong>{ticketData.ticket.title}</Text>,
    },
    {
      key: 1,
      span: 40,
      label: t("maintenance:monitor.daily_schedule.print.ticket.source"),
      children: <Text>{ticketData.source?.name}</Text>,
    },
    {
      key: 2,
      span: 15,
      label: t("maintenance:monitor.daily_schedule.print.ticket.priority"),
      children: <PriorityTag asIcon />,
    },
  ];

  return (
    <Card styles={{ body: { padding: 0 } }}>
      <FixedDescription>
        <Descriptions
          column={100}
          layout="vertical"
          bordered
          size="small"
          items={descriptionItems}
        />
        <MessagesTile messages={ticketData.messages} />
        <UserNoticeTile />
      </FixedDescription>
    </Card>
  );
});
